import { render, staticRenderFns } from "./OrganizationMenu.vue?vue&type=template&id=395b478c&"
import script from "./OrganizationMenu.vue?vue&type=script&lang=js&"
export * from "./OrganizationMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports